import React from "react";

function createData(id, name, status, subject, grade, assignedTo, createdBy) {
    return { id, name, status, subject, grade, assignedTo, createdBy };
}


export const SampleData = [
    createData('1', 'Test1', 'Draft', 'Maths', '4', 'Student1', 'Parent1'),
    createData('2', 'Test2', 'Published', 'English', '4', 'Student1', 'Teacher1'),
    createData('3', 'Test3', 'Draft', 'Science', '4', 'Student1', 'Parent1'),
    createData('4', 'Test4', 'Finished', 'Social Science', '4', 'Student1', 'Teacher1'),
    createData('5', 'Test5', 'Attempted', 'Social Science', '4', 'Student1', 'Teacher1'),
    createData('6', 'Test6', 'NotAttempted', 'Social Science', '4', 'Student1', 'Teacher1'),
];

function createAddedQuestionsData(question, answer, solution) {
    return {question, answer, solution}
}

export const AddedQuestionSampleData = [
    createAddedQuestionsData("question1", "answer1", "solution1"),
    createAddedQuestionsData("question2", "answer2", "solution2"),
    createAddedQuestionsData("question3", "answer3", "solution3"),
    createAddedQuestionsData("question4", "answer4", "solution4"),
]

function createAttemptedQuestionsData(question, response, answer, solution) {
    return {question, response, answer, solution}
}

export const AttemptedQuestionSampleData = [
    createAttemptedQuestionsData("question1", "response1", "answer1", "solution1"),
    createAttemptedQuestionsData("question2", "response2", "answer2", "solution2"),
    createAttemptedQuestionsData("question3", "response3", "answer3", "solution3"),
    createAttemptedQuestionsData("question4", "response4", "answer4", "solution4"),
]
